import React from 'react';
import { Box } from '@mui/material';
import { Switch, Input, Typography } from '@sm-dashboard/ui-components';

interface BusinessInfoFormProps {
  formData: {
    businessName: string;
    businessNameForInvoicing: string;
    businessEmail: string;
    businessPhone: string;
    hasWhatsapp: boolean;
  };
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  isShaliach: boolean;
}

const BusinessInfoForm: React.FC<BusinessInfoFormProps> = ({ formData, setFormData, isShaliach }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData((prev: any) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setFormData((prev: any) => ({ ...prev, [e.target.name]: checked }));
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ mb: '0.35em' }}>
        <Typography variant="h6">{isShaliach ? 'פרטי העסק / השירות' : 'פרטי העסק'}</Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Input
          name="businessName"
          label="שם העסק לתצוגה"
          value={formData.businessName}
          onChange={handleChange}
          required
          inputProps={{ maxLength: isShaliach ? 70 : 40 }}
          helperText={`${formData.businessName.length}/${isShaliach ? 70 : 40} תווים`}
        />
        {!isShaliach && (
          <Input
            name="businessNameForInvoicing"
            label="שם העסק לחשבונית"
            value={formData.businessNameForInvoicing}
            onChange={handleChange}
            required
          />
        )}
        <Input
          name="businessEmail"
          label="אימייל העסק"
          value={formData.businessEmail}
          onChange={handleChange}
          required
          type="email"
          inputProps={{
            pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$'
          }}
          helperText="שדה חובה - אימייל תקין נדרש לקבלת אישורים"
        />
        <Input
          name="businessPhone"
          label="טלפון העסק לתצוגה"
          value={formData.businessPhone}
          onChange={handleChange}
          required
          inputProps={{
            pattern: '^[0-9]{10}$|^0[0-9]{1,2}-?[0-9]{7}$|^\\+972-?[0-9]{1,2}-?[0-9]{7}$'
          }}
          helperText="לדוגמה: 0501234567"
        />
        <Switch
          label="האם יש ווטסאפ בטלפון זה?"
          name="hasWhatsapp"
          checked={formData.hasWhatsapp}
          onChange={handleSwitchChange}
        />
      </Box>
    </Box>
  );
};

export default BusinessInfoForm;
